

import React, { useState, useEffect } from 'react';
import { getRol } from '../../../_utils/storage_handler';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { Checkbox } from 'antd';
import Box from '@mui/material/Box';
import { 
  findOrdersDespEvent,
  findOrdersDetailCheckedEvent,
  findOrdersEvent,
  resetCheckeOrdersEvent
} from '../../../_events/orders/find_order.event';
import { deleteOrdersEvent, displayPDFOrderEvent,remisionOrdersEvent,checkProductEvent } from '../../../_events/orders/order_box.event';
import { message } from 'antd';
import PrimaryProgress from '../../../containers/progress/primary_progress';
import DespatchBoxBoxList from './despatch_list';
import Chip from '@mui/material/Chip';
import BasicPopconfirm from '../../../containers/popconfirms/basic_popconfirm';
import { isNotViewer } from '../../../_utils/render_actions';
import Modal from '@mui/material/Modal';
import DepathModal from './despath_modal';
import { editOrderCheckEvent } from '../../../_events/orders/edit.event';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '80%',
  bgcolor: 'background.paper',
  border: '2px solid #fff',
  borderRadius: '20px',
  boxShadow: 24,
  p: 4,
};


const DespatchBox = () => {

  const in_process='DESP';
  const [allChecked, setAllChecked] = useState(false);
  const [order, setOrder] = useState([]);
  const [modalData, setModalData] = useState({});
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [openPDF, setOpenPDF] = React.useState(false);
  const [openPDFRemision, setOpenPDFRemision] = React.useState(false);
  const [pdf, setPDF] = React.useState(null);
  const [process_state, setProcess_state] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [selectedCheckboxes, setSelectedCheckboxes] = useState({});
  const [selectedProducts, setSelectedProducts] = useState({});
  const [selectedProductsRight, setSelectedProductsRight] = useState({});
  const [selectedClients, setSelectedClients] = useState({});
  const [showRemisionButton, setShowRemisionButton] = useState(false);
  const [clientsSelected, setClientsSelected] = useState({}); 
  const [inputValues, setInputValues] = useState({});
  const [addInfoOrders, setAddInfoOrders] = useState({});
  const [selectValues, setSelectValues] = useState({});
  const [copySPR, setCopySPR] = useState({});
  const [pdfs, setPdfs] = useState(null);
  const [boxProducts, setBoxProducts] = useState({});

  const handleBoxProducts = (orderNumber, uuidDetail, inputValue) => {
    setBoxProducts((prevBoxProducts) => ({
      ...prevBoxProducts,
      [orderNumber]: {
        ...(prevBoxProducts[orderNumber] || {}),
        [uuidDetail]: inputValue,
      },
    }));
  };
  

  const handleClosePDFRemision = () => {
    setPdfs(null);
    setOpenPDFRemision(false);
  };
  
  const handleInputChange = (orderNumber, inputValue) => {
    setInputValues((prevInputValues) => ({
      ...prevInputValues,
      [orderNumber]: inputValue,
    }));
  };

  const handleInputAddInfoChange = (orderNumber, inputValue) => {
    setAddInfoOrders((prevInputValues) => ({
      ...prevInputValues,
      [orderNumber]: inputValue,
    }));
  };

  const handleSelectChange = (orderNumber, selectValue) => {
    setSelectValues((prevSelectValues) => ({
      ...prevSelectValues,
      [orderNumber]: selectValue,
    }));
  };

  const loadOrders = () => {
    setAllChecked(false);
    setLoading(true);
    findOrdersEvent('DESP')
    .then(data => {
      let orders_list = [];
      data.list.forEach(obj => {  
        if (obj.uuid != null && obj.id ) {  
          orders_list.push(obj);
        } 
      });
      setOrders(orders_list);
      setLoading(false);
    })
    .catch(err => {
      message.error(err.message);
      setLoading(false);
    });
  }

  const setEditOrder = (o, p) => {
    setOrder({uuid: p.uuid, order: o});
    handleOpen();
  }
  
  const handleClosePDF = () => {
    setOpenPDF(false);
  };
  
  const toggleClientSelection = (clientName) => {
    setSelectedClients((prevSelectedClients) => ({
      ...prevSelectedClients,
      [clientName]: !prevSelectedClients[clientName],
    }));
  };

  
  const handleRemisionButtonClick = () => {

    const updatedSelectedProductsRight = { ...selectedProductsRight };

    Object.keys(addInfoOrders).forEach((orderNumber) => {
      Object.keys(updatedSelectedProductsRight).forEach((clientName) => {
        if (
          updatedSelectedProductsRight[clientName] &&
          updatedSelectedProductsRight[clientName][orderNumber]
        ) {
          updatedSelectedProductsRight[clientName][orderNumber].addInfo = addInfoOrders[orderNumber];
        }
      });
    });

    Object.keys(inputValues).forEach((orderNumber) => {
      Object.keys(updatedSelectedProductsRight).forEach((clientName) => {
        if (
          updatedSelectedProductsRight[clientName] &&
          updatedSelectedProductsRight[clientName][orderNumber]
        ) {
          updatedSelectedProductsRight[clientName][orderNumber].boxOrder = inputValues[orderNumber];
          updatedSelectedProductsRight[clientName][orderNumber].type_box = selectValues[orderNumber]===undefined ? "caja":selectValues[orderNumber];
          updatedSelectedProductsRight[clientName][orderNumber].boxProducts = boxProducts[orderNumber]===undefined ? "":boxProducts[orderNumber];
        }
      });
    });
    
  

    const selectedClientsArray = Object.keys(selectedClients).filter(
      (clientName) => selectedClients[clientName]
    );

    setOpenPDFRemision(true)
    remisionOrdersEvent(selectedProductsRight, selectedClientsArray)
    .then((data) => {
      loadOrders();
      const newPdfs = data.data.bytes;
      setPdfs(newPdfs);
      message.success('PDFs Generados.');
    })
    
  };
  
  
  const handleProductCheckboxChange = (uuid_orderDetail, isChecked) => {
    checkProductEvent(uuid_orderDetail, isChecked)
      .then(json => {
        loadRemisionModalData();
      })
      .catch((error) => {
        console.error(error);
      });
  };
  
  
  const handleCloseModal = () => {
    setOpenModal(false);
    setSelectedProductsRight({});
    setSelectedClients({})
    setShowRemisionButton(false);
    setSelectValues({});
    setBoxProducts({});
    setInputValues({});
    setAddInfoOrders({});
    resetCheckeOrdersEvent()
    .then((data) => {
      loadOrders();
    })
    .catch((error) => {
        console.error(error);
    });
  };

  const handleOpen = () => {         
      setOpen(true);                 
  };

  const agroup = (ordersParam) => {
    let selectedOptions = {};
    ordersParam.forEach(o => {
        if (o.checked === 1) {
          o.ordersDetail.forEach(od => {
            if (od.cod_process === 'DESP') {
              if (!selectedOptions[od.productPrice.client.name]) {
                
                selectedOptions[od.productPrice.client.name] = {
                  client: od.productPrice.client, 
                  orders: [] 
                };
              }
  
              const existingOrder = selectedOptions[od.productPrice.client.name].orders.find(order => order.uuid === o.uuid);
  
              if (!existingOrder) {
                selectedOptions[od.productPrice.client.name].orders.push({
                  uuid: o.uuid,
                  id:o.id, 
                  ordersDetail: [] 
                });
              }
              selectedOptions[od.productPrice.client.name].orders.forEach(order => {
                if (order.uuid === o.uuid) {
                  order.ordersDetail.push(od);
                }
              });
            }
          });
        }
    });
    setModalData(selectedOptions);
  }

  const loadRemisionModalData = () => {
    findOrdersDespEvent()
    .then(json => {
        agroup(json.list);
    })
    .catch(err => {
        message.error(err.message);
    });
    findOrdersDetailCheckedEvent()
    .then(json => {
      console.log(json.list);
      setSelectedProductsRight(json.data);
    })
    .catch(err => {
        message.error(err.message);
    });
  }
  
  const aprove = () => {
    let selectedOptions = {};
    let body = [];
    orders.forEach(o => {
      body.push({uuid: o.uuid, checked: o.checked});
      if (o.checked === 1) {
        o.ordersDetail.forEach(od => {
          if (od.cod_process === 'DESP') {
            if (!selectedOptions[od.productPrice.client.name]) {
              
              selectedOptions[od.productPrice.client.name] = {
                client: od.productPrice.client, 
                orders: [] 
              };
            }

            const existingOrder = selectedOptions[od.productPrice.client.name].orders.find(order => order.uuid === o.uuid);

            if (!existingOrder) {
              selectedOptions[od.productPrice.client.name].orders.push({
                uuid: o.uuid,
                id:o.id, 
                ordersDetail: [] 
              });
            }
            selectedOptions[od.productPrice.client.name].orders.forEach(order => {
              if (order.uuid === o.uuid) {
                order.ordersDetail.push(od);
              }
            });
          }
        });
      }
    });

    if (Object.keys(selectedOptions).length > 0) {

      editOrderCheckEvent(body)
      .then(json => {
        setOpenModal(true);
        loadRemisionModalData();
      })
      .catch(err => 
        message.error(err.message)
      );
      
    }else{
      message.error('De las ordenes seleccionadas, ninguna tiene productos en despacho');
    }
  };


  const deleteOrder = (order) => {
    deleteOrdersEvent(order.uuid)
    .then(data => {
      message.success('Orden eliminada');
      loadOrders();
    })
    .catch(err => {
      message.error(err.message);
    });
  }

  const checkAll = () => {
    let check = allChecked;
    let ordersNew = [...orders];
    ordersNew.forEach(element => {
      element.checked = check ? 0 : 1;
    });
    setAllChecked(!check);
    setOrders(ordersNew);
  }

  const displayPDF = (order) => {
    if(! order) message.error('No hay orden');
    else {
      let o = Object.assign({}, order);
      displayPDFOrderEvent(o)
      .then(data => {
        setPDF(data.data.toAproveJSON);
        setOpenPDF(true);     
      })
      .catch(err => {
        message.error(err.message);
      });
    }    
  }

  useEffect(() => {
    loadOrders();
  }, []);

  let rol = getRol();

  return (
    <Grid container spacing={1} >
        <Grid item xs={12} md={12}>
            <Typography variant="h6" component="h6">
                Bandeja de Despachos 
            </Typography>
            <hr />
            {
              loading ? (
                <PrimaryProgress />
              ) : (
                <Grid container spacing={1}>
                  <Grid item xs={6} md={6}>
                    <div style={{display: 'flex', flexDirection: 'row', width: '100%'}}>
                      <Chip label={`Total: ${orders.length}`} color="primary" variant="outlined" />
                      <Chip label={`Entregas INMEDIATAS: ${orders.filter(o => o.date_delivery === null).length}`} color="error" variant="outlined" />
                      <Chip label={`Seleccionadas: ${orders.filter(o => o.checked === 1).length}`} color="success" variant="outlined" />
                    </div>
                  </Grid>
                  <Grid item xs={6} md={6}>
                    <div style={{display: 'flex', flexDirection: 'row-reverse', width: '100%'}}>
                      <BasicPopconfirm
                        label='Aprobar órdenes'
                        title='¿Seguro/a que deseas aprobar todas las órdenes seleccionadas?'
                        onConfirm={ () => { isNotViewer(rol) ? aprove() : alert('Usuario informativo')}}
                      />
                    </div>
                  </Grid>
                  <Grid item xs={12} md={12}>
                    <div style={{width: '100%', display: 'flex', flexDirection: 'row-reverse'}}>
                      <Checkbox
                        style={{marginRight:'55px'}} 
                        checked={allChecked}
                        onClick={event => {
                                event.stopPropagation();
                        }}
                        onChange={() => {
                            checkAll();
                        }}>
                      </Checkbox>
                    </div>                 
                  </Grid>
                  <Grid item xs={12} md={12}>
                    <DespatchBoxBoxList
                      
                      data={orders}
                      process={process_state}
                      setEditOrder={(o, p) => setEditOrder(o, p)}
                      updateDataOrdersChecked={(d) => {
                        let index = orders.findIndex(o => o.uuid === d.uuid);
                        if(index === -1){
                          message.error('No se logró seleccionar');
                        } else {
                          let orders_updated = [...orders];
                          orders_updated[index].checked = orders_updated[index].checked === 0 ? 1 : 0;
                          setOrders(orders_updated);
                        }
                      }}
                      deleteOrder = {(o) => {isNotViewer(rol) ? deleteOrder(o) : alert('Usuario informativo')}}
                      displayPDF = {(o) => displayPDF(o)}
                    />
                  </Grid>
                </Grid>
              )
            }
        </Grid>
        <>
        <DepathModal 
          modalData={modalData}
          openModal={openModal}
          handleCloseModal={handleCloseModal}
          handleProductCheckboxChange={handleProductCheckboxChange}
          selectedProductsRight={selectedProductsRight}
          addInfoOrders={addInfoOrders}
          handleInputAddInfoChange={handleInputAddInfoChange}
          handleInputChange={handleInputChange}
          handleSelectChange={handleSelectChange}
          inputValues={inputValues}
          selectValues={selectValues}
          selectedClients={selectedClients}
          setOpenPDF={setOpenPDF}
          setPDF={setPDF}
          showRemisionButton={showRemisionButton}
          toggleClientSelection={toggleClientSelection} 
          handleRemisionButtonClick={handleRemisionButtonClick}
          loadRemisionModalData={loadRemisionModalData}    
          handleBoxProducts={handleBoxProducts}
          boxProducts={boxProducts}
        />
      <Modal
            open={openPDF}
            onClose={handleClosePDF}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={style}>
              <Grid container spacing={1}>
                {
                  !pdf ? <>Cargando...</> :
                  <Grid item xs={12} md={12}>
                    <object width="100%" height="600px" 
                      data={`data:application/pdf;base64,${pdf}`} 
                      type="application/pdf" className="internal"
                    >
                      <embed 
                          src={`data:application/pdf;base64,${pdf}`}
                          type="application/pdf"
                      />
                    </object>
                  </Grid>
                }
              </Grid>
            </Box>
        </Modal>

        <Modal
          open={openPDFRemision}
          onClose={handleClosePDFRemision}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <Grid container spacing={1}>
              {pdfs === null ? (
                <>Procesando remision(es)...</>
              ) : (
                <Grid item xs={12} md={12}>
                    <object width="100%" height="600px" 
                      data={`data:application/pdf;base64,${pdfs}`} 
                      type="application/pdf" className="internal"
                    >
                      <embed 
                        src={`data:application/pdf;base64,${pdfs}`}
                        type="application/pdf"
                      />
                    </object>
                  </Grid>
              )}
            </Grid>
          </Box>
        </Modal>

    </>
    </Grid>
);}

export default DespatchBox;
